export function isLowStock(inventory, cartQuantity, tracked, available) {
  const remaining = inventory - cartQuantity;
  return tracked && available && Number.isFinite(inventory) && remaining > 0 && remaining <= 5;
}

export function stockBadgeLeft(buttonLeft, buttonWidth, badgeWidth, viewportWidth) {
  return Math.max(4, Math.min(buttonLeft + (buttonWidth - badgeWidth) / 2, viewportWidth - badgeWidth - 4));
}

if (typeof document !== 'undefined') {
  const selector = '[data-solvia-low-stock]';
  const requests = new WeakMap();

  function positionBadges() {
    document.querySelectorAll(selector).forEach((badge) => {
      const fieldset = badge.closest('fieldset');
      const selected = fieldset.querySelector('input:checked')?.closest('label');
      badge.hidden = !selected || !isLowStock(
        Number(badge.dataset.inventory), Number(badge.dataset.cartQuantity),
        badge.dataset.tracked === 'true', badge.dataset.available === 'true'
      );
      if (badge.hidden) return;
      const button = selected.getBoundingClientRect();
      const parent = fieldset.getBoundingClientRect();
      const width = badge.getBoundingClientRect().width;
      const left = stockBadgeLeft(button.left, button.width, width, window.innerWidth);
      badge.style.left = `${left - parent.left}px`;
      badge.style.top = '0px';
      const originTop = badge.getBoundingClientRect().top;
      badge.style.top = `${button.top - originTop - badge.offsetHeight - 8}px`;
    });
  }

  async function refreshPicker(picker) {
    requests.get(picker)?.abort();
    const controller = new AbortController();
    requests.set(picker, controller);
    picker.querySelectorAll(selector).forEach((badge) => { badge.hidden = true; badge.dataset.available = 'false'; });
    try {
      const url = new URL(picker.dataset.productUrl, location.origin);
      url.searchParams.set('section_id', picker.dataset.sectionId);
      const options = [...picker.querySelectorAll('input:checked, option:checked')]
        .map((input) => input.dataset.optionValueId).filter(Boolean);
      if (options.length) url.searchParams.set('option_values', options.join(','));
      const response = await fetch(url, { signal: controller.signal, cache: 'no-store' });
      if (!response.ok) throw new Error('Inventory refresh failed');
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const source = [...html.querySelectorAll('variant-picker')].find((el) => el.dataset.blockId === picker.dataset.blockId);
      if (!source || !picker.isConnected) return;
      picker.querySelectorAll(selector).forEach((badge, index) => {
        const fresh = source.querySelectorAll(selector)[index];
        if (!fresh) return;
        for (const key of ['inventory', 'cartQuantity', 'tracked', 'available']) badge.dataset[key] = fresh.dataset[key];
      });
      positionBadges();
    } catch (error) {
      // A failed refresh leaves the notice hidden instead of showing stale availability.
      if (error.name !== 'AbortError') console.warn('Low stock notice could not be refreshed.');
    }
  }

  document.addEventListener('variant:selected', (event) => {
    const picker = event.target.closest('variant-picker');
    if (!picker) return;
    requests.get(picker)?.abort();
    picker.querySelectorAll(selector).forEach((badge) => { badge.hidden = true; badge.dataset.available = 'false'; });
  });
  document.addEventListener('variant:update', () => requestAnimationFrame(positionBadges));
  document.addEventListener('cart:update', () => {
    document.querySelectorAll('variant-picker:has([data-solvia-low-stock])').forEach(refreshPicker);
  });
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) document.querySelectorAll('variant-picker:has([data-solvia-low-stock])').forEach(refreshPicker);
  });
  window.addEventListener('resize', () => requestAnimationFrame(positionBadges));
  document.fonts.ready.then(positionBadges);
  requestAnimationFrame(positionBadges);
}
